import { Component, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/api-url-helper';
import { CommonErrorMessages } from 'src/app/constants/ErrorMessages';
import { LoginLabelConstants } from 'src/app/constants/LabelMessages';
import { CommonService } from 'src/app/services/common/common.service';
import { SharedService } from 'src/app/services/shared-service/shared.service';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})

export class LoginComponent {

  // Common Properties
  loginForm: FormGroup
  submitted: boolean = false;
  isShowPassword: boolean = false;
  errorConstants: any;
  labelConstants: any;
  classSessionId:any;
  customerId:any;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private spinner: NgxSpinnerService,
    private toast: ToastrService,
    private api: ApiUrlHelper,
    private commonService: CommonService,
    private storageService: StorageService,
    private sharedService: SharedService,
    private elementRef: ElementRef,
    private activatedRoute:ActivatedRoute
  ) { }

  ngOnInit() {
    this.sharedService.setData('Sign in');
    this.commonService.setBannerData('');
    this.loginForm = this.formBuilder.group({
      Email: ['', [Validators.required, Validators.email, Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
      password: ['', [Validators.required]],
    });
    this.errorConstants = CommonErrorMessages;
    this.labelConstants = LoginLabelConstants;
    if (this.activatedRoute.snapshot.params['id']) {
      this.classSessionId = Number.parseInt(this.commonService.Decrypt(this.activatedRoute.snapshot.params['id']));
      this.customerId = Number.parseInt(this.commonService.Decrypt(this.activatedRoute.snapshot.params['customerId'])); 
    }
    if (localStorage.getItem('authToken')) {
      if(this.classSessionId>0){
        let encryptedClassSessionId = this.commonService.EncryptForNotSlash(this.classSessionId);
        let encryptedCustomerId = this.commonService.EncryptForNotSlash(this.customerId);

        this.router.navigate([`session/${encryptedClassSessionId}/${encryptedCustomerId}`])
      }
      else{
        this.router.navigate(['/']);
      }
    }
  }

  get loginFormControl() {
    return this.loginForm.controls;
  }

  clearLocalStorage() {
    localStorage.removeItem("authToken");
    localStorage.removeItem("email");
    localStorage.removeItem("userId");
    localStorage.removeItem("userName");
    localStorage.removeItem("userImage");
  }

  onLogin() {
    this.submitted = true;
    if (this.loginForm.invalid || !this.loginForm.value.Email || !this.loginForm.value.password) {
      return;
    }
    this.spinner.show();
    let LoginObj = {
      Email: this.loginForm.value.Email,
      Password: this.loginForm.value.password,
      CustomerUID: ((this.storageService.getValue('Fingerprint') && this.storageService.getValue('Fingerprint') != "") ? this.storageService.getValue('Fingerprint') : null)
    }
    let apiUrl = this.api.apiUrl.Account.CustomerLogin;
    this.commonService.doPost(apiUrl, LoginObj).pipe().subscribe({
      next: (response) => {
        if (response.success) {
          this.spinner.hide();
          this.storageService.setValue('authToken', response.data.token);
          this.storageService.setValue('email', this.commonService.EncryptNew(response.data.email));
          this.storageService.setValue('userId', this.commonService.EncryptNew(response.data.customerId.toString()));
          this.storageService.setValue('userName', response.data.firstName + ' ' + response.data.lastName);
          this.storageService.setValue('userImage', response.data.customerImage);
          localStorage.removeItem("Fingerprint");
          if(this.classSessionId>0){
            let encryptedClassSessionId = this.commonService.EncryptForNotSlash(this.classSessionId);
            let encryptedCustomerId = this.commonService.EncryptForNotSlash(this.customerId);
            this.router.navigate([`session/${encryptedClassSessionId}/${encryptedCustomerId}`])
          }
          else{
            this.router.navigate(['/']);
          }
        }
        else {
          this.spinner.hide();
          this.toast.error(response.message);
        }
      },
      error: (er) => {
        this.spinner.hide();
        console.error(er);
        this.clearLocalStorage();
      },
    });
  }

  togglePasswordVisibility() {
    this.isShowPassword = !this.isShowPassword
  }

  onForgotPassword() {
    this.router.navigate(['/forgot-password']);
  }
  onRegistration() {
    this.router.navigate(['/registration']);
  }

  redirectToTop() {
    this.elementRef.nativeElement.ownerDocument.defaultView.scrollTo({
      top: 0,
      behavior: 'smooth' // Optional: Smooth scrolling animation
    });
  }
}